import ApiService from 'services/ApiService';
import {
  IGetAnalystsByCompanyIdResponse,
  IPutAnalystInInspectionsResponse,
  IAnalystService,
} from './analystService.types';

const AnalystService: IAnalystService = {
  getAnalysts: async (companiesIds) => {
    const {
      data: { analysts },
    } = await ApiService.get<IGetAnalystsByCompanyIdResponse>('/accounts/analysts', {
      params: {
        companiesIds: companiesIds.join(','),
      },
    });

    return analysts;
  },

  putAnalystInInspections: async (accountId, inspectionsIds) => {
    const {
      data: { inspections },
    } = await ApiService.put<IPutAnalystInInspectionsResponse>(`/inspections/analyst`, {
      accountId,
      inspectionsIds,
    });

    return inspections;
  },
};

export default AnalystService;
